import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";

import {
  updateStore
} from "appRedux/actions/StoreCoupons";

import {
  fetchStores, editStoreImage
} from "appRedux/actions/Coupons";


const FormItem = Form.Item;

class Basic extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    id: '', visible: false,
    name: '', phoneNumber: '', email: ''
    ,
    validateStatusNombre: '', helpNombre: '',
    validateStatusEmail: '', helpEmail: '',
  };

  showModal = () => {
    this.setState({
      visible: true,
      id: this.props.recording.id,
      name: this.props.recording.name,
      email: this.props.recording.email,
      phoneNumber: this.props.recording.phone,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    this.props.fetchStores();
    this.setState({ visible: false });
    if (this.state.name == '') { this.setState({ validateStatusNombre: '', helpNombre: '', }); }
    if (this.state.email == '') { this.setState({ validateStatusEmail: '', helpEmail: '', }); }

  };


  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El editado de la tienda se ha creado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al editar la tienda.',
      });
    }

  };


  onChangeS = (checked) => {
    if (checked) {
      this.setState ({active:1});      
    } else {this.setState ({active:0});}   }


  onHandleClick = (event) => {
    event.preventDefault();
    let { name, email } = this.state;
    if (name && email) {
      this.props.editStoreImage(this.state, () => { this.props.fetchStores(); });
      this.onNotification('success');
    } else {

      if (this.state.name == '') { this.setState({ validateStatusNombre: 'error', helpNombre: 'Nombre es un campo obligatorio.', }); } else { this.setState({ validateStatusNombre: '', helpNombre: '' }); }
      if (this.state.email == '') { this.setState({ validateStatusEmail: 'error', helpEmail: 'Correo es un campo obligatorio.', }); } else { this.setState({ validateStatusEmail: '', helpEmail: '' }); }

      let messageError = 'Rellene los campos obligatorios.';
      this.onNotification('error', messageError);
    }
  }

  handlChangeImage = (selectorFiles) => {
    const file = selectorFiles[0];
    this.setState({ imageUrl: file });
  }


  render() {
    return (
      <div >
        <Button type="primary" onClick={this.showModal}><i className="icon icon-edit" /></Button>
        <Modal
          afterClose={() => this.props.fetchStores()}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >




          <Card className="gx-card" title="Editar tienda">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24} >
                  <FormItem label='Tienda *:' labelCol={{ xs: 9, sm: 9, lg: 9, md: 9 }} validateStatus={this.state.validateStatusNombre} help={this.state.helpNombre}>
                    <Input
                      required
                      placeholder="Nombre de la tienda"
                      value={this.state.name}
                      onChange={

                        (event) => {
                          this.setState({
                            name: event.target.value
                          });

                          if (event.target.value != '') { this.setState({ validateStatusNombre: '', helpNombre: '' }); } else { this.setState({ validateStatusNombre: 'error', helpNombre: 'Nombre es un campo obligatorio.' }); }


                        }
                      }
                    />
                  </FormItem>

                </Col>


                <Col lg={12} md={12} sm={12} xs={24} >
                  <FormItem label='Teléfono :' labelCol={{ xs: 9, sm: 9, lg: 9, md: 9 }}>
                    <Input
                      placeholder="Número de teléfono"
                      value={this.state.phoneNumber}
                      onChange={
                        (event) => {
                          this.setState({
                            phoneNumber: event.target.value
                          });
                        }
                      }
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24} >
                  <FormItem label='Correo *:' labelCol={{ xs: 10, sm: 10, lg: 10, md: 10 }} validateStatus={this.state.validateStatusEmail} help={this.state.helpEmail} >
                    <Input
                      required
                      placeholder="Correo electrónico"
                      value={this.state.email}
                      onChange={
                        (event) => {
                          this.setState({
                            email: event.target.value
                          });
                          if (event.target.value != '') { this.setState({ validateStatusEmail: '', helpEmail: '' }); } else { this.setState({ validateStatusEmail: 'error', helpEmail: 'Correo es un campo obligatorio.' }); }
                        }
                      }
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24} >
                  <Card
                    type="inner"
                    title="Foto de la tienda"
                  >
                    <FormItem label='Tamaño: (200 x 200 px)' labelCol={{ xs: 24, sm: 24, lg: 24, md: 24 }} ></FormItem>
                    <input
                      type="file"
                      onChange={
                        (event) => {
                          this.handlChangeImage(event.target.files)
                        }
                      }
                    />
                  </Card>
                </Col>


              </Row>


            </form>
          </Card>







        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ placeStores }) {
  return {
    placeStores,
  }
}

export default connect(mapStateToProps, { updateStore, fetchStores, editStoreImage })(Basic);



// WEBPACK FOOTER //
// ./src/routes/main/Store/ModalEdit.js